module.exports = __webpack_public_path__ + "img/varejo.ce91efab.jpg";